import React from "react";
import ReactDOM from "react-dom";
import BaseComponent from "../../../baseComponent.js";
import Legend from "./legend.jsx";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import WidgetType from "../../../../core/constants/widgetType.js";
import styles from "./legends.scss";
import DatasetDetail from "./../../../data-bank/dataset-detail/datasetDetail.jsx";
import DatasetService from "../../../../core/services/datasetService.js";

export default class Legends extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.subscribe(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_START, this.showDropIndicator);
    this.subscribe(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_END, this.hideDropIndicator);
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  showDropIndicator() {
    if (this.props.widgetType === WidgetType.TEXTUAL || this.props.widgetType === WidgetType.GAUGE) {
      if (this.props.legends.length > 0) return;
    }
    $(this.refs.container).addClass(styles.dropActivated);
  }

  hideDropIndicator() {
    $(this.refs.container).removeClass(styles.dropActivated);
  }

  handleDrop(e) {
    e.preventDefault();
    let key = $(e.target).attr("data-key");
    let data = JSON.parse(e.dataTransfer.getData('data'));
    e.persist();

    // prevent adding more than one legend
    if (this.props.widgetType === WidgetType.TEXTUAL ||
      this.props.widgetType === WidgetType.GAUGE) {
      if (this.props.legends.length > 0) return;
    }

    if (this.props.isStudioWidget) {
      this.props.handleDrop(data);
    } else {
      DatasetService.checkUserDatasetSubscription(data.dataset.persistenceId).then(subscriptions => {
        if (subscriptions.length > 0) {
          if (this.props.widgetType === WidgetType.TECHNICAL_ANALYSIS_CHART) {
            this.props.handleDrop(data, true);
          } else {
            this.props.handleDrop(data);
          }
        }
        else {
          this.props.callback(data);
        }
      });
    }
  };

  preventDefault(e) {
    e.preventDefault();
  }

  render() {
    let legendsComponents = [], legendsGroup = {};

    for (let i = 0; i < this.props.legends.length; i++) {
      let groupId = this.props.legends[i].parameters.groupId;
      if (groupId != null) {
        if (legendsGroup.hasOwnProperty(groupId)) {
          legendsGroup[groupId].push(this.props.legends[i]);
        } else {
          legendsGroup[groupId] = [this.props.legends[i]];
        }
      } else {
        let legendId = this.props.legends[i].id;
        legendsGroup[legendId] = [this.props.legends[i]];
      }
    }

    for (let groupId in legendsGroup) {
      let isSelected = false;
      if (legendsGroup[groupId].length === 2) {
        if (legendsGroup[groupId][0].id === this.props.currentLegendId) isSelected = true;
        legendsComponents.push(<Legend legend={legendsGroup[groupId][0]}
                                       secondaryLegend={legendsGroup[groupId][1]}
                                       isSelected={isSelected}
                                       removeCurrentLegend={this.props.removeCurrentLegend}
                                       changeCurrentLegend={this.props.changeCurrentLegend} key={groupId}/>)
      } else {
        if (legendsGroup[groupId][0].id === this.props.currentLegendId) isSelected = true;
        legendsComponents.push(<Legend legend={legendsGroup[groupId][0]}
                                       isSelected={isSelected}
                                       removeCurrentLegend={this.props.removeCurrentLegend}
                                       changeCurrentLegend={this.props.changeCurrentLegend} key={groupId}/>)
      }
    }

    let customStyle = {};
    if (this.props.isStudioWidget) {
      customStyle = {
        minHeight: "40px",
        padding: "8px 0 0 0"
      }
    }

    return (

      <div className={styles.legends} style={customStyle} ref="container" name="legendContainer"
           onDragOver={this.preventDefault} onDrop={this.handleDrop}>
        <div ref="datasetDetailContainer"></div>
        {legendsComponents}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legends/legends.jsx